<!--
 * @Description: 按钮组
 * @Version: 2.0
 * @Autor: daikeyi
 * @Date: 2020-06-05 15:25:04
 * @LastEditors: daikeyi
 * @LastEditTime: 2021-01-20 11:22:35
-->
<template>
    <div class='btnAssStyle'>
        <van-button round size="small" @click='clickBtn' v-if='type === 1' :disabled="disabled">{{text}}</van-button>
        <van-button round size="small" class='redButton' @click='clickBtn' v-if='type === 2'>{{text}}</van-button>
    </div>
</template>
<script>
export default {
    props: ['text', 'type', 'disabled'],
    data () {
        return {

        };
    },
    methods: {
        clickBtn() {
            this.$emit('fromChildClick');
        }
    }
};
</script>
<style lang="scss" scoped>
.btnAssStyle{
    display: inline-block;
    /deep/{
        .van-button{
            width:74px;
        }
    }
}
</style>
